export const room = [
  {
    path: '/room',
    component: () => import(/* webpackChunkName: "room" */ '@/views/room/Room'),
    children: [
      {
        path: 'create',
        component: () => import(/* webpackChunkName: "room" */ '@/views/room/components/RoomEditBody'),
      },
      {
        path: ':id/edit',
        component: () => import(/* webpackChunkName: "room" */ '@/views/room/components/RoomEditBody'),
      },
    ]
  },
]
